const binding = { modules: {}, dataActions: {} };

    (binding.modules['last-viewed'] = {
        c: () => require('partner/modules/last-viewed/last-viewed.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'last-viewed',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/last-viewed'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|last-viewed|last-viewed'] = {
                c: () => require('partner/modules/last-viewed/last-viewed.view.tsx'),
                cn: '__local__-__local__-last-viewed'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };